module.exports = __webpack_public_path__ + "img/Flag_of_Uzbekistan.f0eb4284.svg";